import React, { useContext, useEffect, useState } from 'react'
import { Form, Formik, FieldArray, Field } from 'formik'
import { toast } from 'react-toastify'
import { FiPlus, FiSave, FiTrash } from 'react-icons/fi'

import { Container } from './styles'
import Card from '../../../../components/Card'
import { TipContext } from '../../../../contexts/TipContext'
import { loadTips } from '../../../../util/tip'
import { api, authHeaders } from '../../../../services/api'
import { Button, Checkbox, Textbox } from '../../../../components/Form'
import { GlobalContext } from '../../../../contexts/GlobalContext'

export default function () {
	const { user, checkException } = useContext(GlobalContext)
	const { setCodigo, tips } = useContext(TipContext)

	const [initialValues, setInitialValues] = useState({})
	const [eAtualizacao, setEAtualizacao] = useState(false)

	async function loadPerguntasBase() {
		const { novas, perguntas } = await api.get(`representante/${user.pessoa.id}/pergunta_trl`, authHeaders())

		const initialData = {}

		for (const { nivel, descricao, perguntas: perguntasNivel } of perguntas) {
			initialData[`perguntas_nivel_${nivel}`] = {
				nivel,
				descricao,
				perguntas: perguntasNivel.map(p => ({
					id: p.id,
					pergunta: p.pergunta,
					obrigatorio: p.obrigatorio
				}))
			}
		}

		setInitialValues(initialData)

		setEAtualizacao(!novas)
	}

	async function handleSalvarPerguntas(values) {
		try {
			await api.put(`representante/${user.pessoa.id}/pergunta_trl`, values, authHeaders())

			toast.success('As informações foram salvos.')

			loadPerguntasBase()
		} catch (e) {
			checkException(e)
		}
	}

	useEffect(() => {
		loadPerguntasBase()
	}, [])

	useEffect(() => {
		loadTips(setCodigo, 'form_trl')
	}, [])

	const niveisPerguntas = Object.values(initialValues)

	if (!niveisPerguntas.length) {
		return null
	}

	return (
		<Container>
			<main>
				<Card className="flex flex-col">
					<h1>Definição de pré-requisitos TRL</h1>

					<p className="mt-4 ml-2">{tips.formulario}</p>

					<Formik
						onSubmit={handleSalvarPerguntas}
						initialValues={initialValues}
						enableReinitialize
					>
						{({ setFieldValue, values }) => {
							return (
								<Form className="mt-4 flex flex-col">
									{niveisPerguntas.map(perg => (
										<div key={perg.nivel}>
											<h1 style={{ fontSize: 16 }} className="ml-2">
												Nível {perg.nivel} - {perg.descricao}
											</h1>

											<FieldArray
												name={`perguntas_nivel_${perg.nivel}.perguntas`}
												render={({ push, remove }) => {
													return (
														<div className="flex flex-col">
															{values[`perguntas_nivel_${perg.nivel}`].perguntas.map((_, idx) => {
																return (
																	<div key={idx} className="flex gap-2">
																		<Textbox
																			name={`perguntas_nivel_${perg.nivel}.perguntas.${idx}.pergunta`}
																			label="Pré-requisito"
																		/>

																		<Checkbox
																			name={`perguntas_nivel_${perg.nivel}.perguntas.${idx}.obrigatorio`}
																			label="Obrigatório?"
																			handleChange={e => { setFieldValue(e.target.name, e.target.checked) }}
																		/>

																		<FiTrash
																			size={16}
																			onClick={() => { remove(idx) }}
																			className="cursor-pointer hover:opacity-80 self-center mt-5"
																		/>

																		<Field type="hidden" name={`perguntas_nivel_${perg.nivel}.perguntas.${idx}.id`} />
																	</div>
																)
															})}

															<Button
																onClick={() => {
																	push({})
																}}
																className="transparent self-center"
																style={{ marginTop: 16 }}
															>
																Adicionar pré-requisito
																<FiPlus size={16} />
															</Button>
														</div>
													)
												}}
											/>
										</div>
									))}

									<Button type="submit" className="white w-fit self-end" style={{ marginTop: 16 }} tooltip="Ao definir as perguntas TRL, não será possível alterá-las depois.">
										{eAtualizacao ? 'Salvar alterações' : 'Cadastrar perguntas'}
										<FiSave size={16} />
									</Button>
								</Form>
							)
						}}
					</Formik>
				</Card>
			</main>
		</Container>
	)
}
